import store from '../store'

export const notificationApi = {
  show(val) {
    store.commit('SET_NOTIFY', val)
  },
  hide() {
    store.commit('SET_NOTIFY', null)
  },
  showError(error) {
    store.commit('SET_ERROR', error)
  }
}